import InflightVehiclePanel from './InflightVehiclePanel';
import ReadyForTakeoffVehiclePanel from './ReadyForTakeoffVehiclePanel';
import PostflightVehiclePanel from './PostflightVehiclePanel';
import WaitingOnDockVehiclePanel from './WaitingOnDockVehiclePanel';
import EmptyVehiclePanel from './EmptyVehiclePanel';
import { useGcsStore } from '../../../store/useGcsStore';
import type { VehicleId } from '../../../types/gcs/vehicle';
import { VehicleStatusCategory } from '../../../types/ui/vehicleStatusCategory';
import { selectVehicleStatusCategory } from '../../../store/selectors/selectVehicleStatusCategory';

interface VehiclePanelProps {
  vehicleId: VehicleId;
  gcsId: string;
  onClose: () => void;
  onFocusVehicle: () => void;
}

function VehiclePanel({ vehicleId, gcsId, onClose, onFocusVehicle }: VehiclePanelProps) {
  const category = useGcsStore((state) => selectVehicleStatusCategory(state.data, gcsId, vehicleId));

  switch (category) {
    case VehicleStatusCategory.INFLIGHT_NOMINAL:
    case VehicleStatusCategory.INFLIGHT_FAILURE_MODE:
      return (
        <InflightVehiclePanel vehicleId={vehicleId} gcsId={gcsId} onClose={onClose} onFocusVehicle={onFocusVehicle} />
      );

    case VehicleStatusCategory.READY_FOR_TAKEOFF:
      return (
        <ReadyForTakeoffVehiclePanel
          vehicleId={vehicleId}
          gcsId={gcsId}
          onClose={onClose}
          onFocusVehicle={onFocusVehicle}
        />
      );

    case VehicleStatusCategory.POSTFLIGHT:
      return (
        <PostflightVehiclePanel vehicleId={vehicleId} gcsId={gcsId} onClose={onClose} onFocusVehicle={onFocusVehicle} />
      );

    case VehicleStatusCategory.WAITING_ON_DOCK:
      return (
        <WaitingOnDockVehiclePanel
          vehicleId={vehicleId}
          gcsId={gcsId}
          onClose={onClose}
          onFocusVehicle={onFocusVehicle}
        />
      );

    case VehicleStatusCategory.ON_GROUND:
    default:
      return (
        <EmptyVehiclePanel vehicleId={vehicleId} gcsId={gcsId} onClose={onClose} onFocusVehicle={onFocusVehicle} />
      );
  }
}

export default VehiclePanel;
